module.exports = __webpack_public_path__ + "img/index12.568ae8dd.jpg";